import * as React from 'react';
import { ArticleHeading3, ArticleParagraph1, LinkButton } from '@cian/ui-kit';
import * as styles from './ReliableDeveloper.css';
import reliableIcon from './assets/reliability-block-icon.svg';

interface IReliableDeveloperProps {
  checkingUrl: string;
  description: string;
  onButtonClick(): void;
}

export function ReliableDeveloper({ checkingUrl, description, onButtonClick }: IReliableDeveloperProps) {
  return (
    <article className={styles['reliable']}>
      <span className={styles['reliable__icon']}>
        <img src={reliableIcon} alt="Надежный Застройщик" width={80} height={80} />
      </span>

      <div className={styles['reliable__title']}>
        <ArticleHeading3>Надежный застройщик</ArticleHeading3>
      </div>

      <div className={styles['reliable__description']}>
        <ArticleParagraph1>{description}</ArticleParagraph1>
      </div>

      <LinkButton
        theme="fill_white_primary"
        size="XS"
        href={checkingUrl}
        rel="noopener noreferrer"
        target="_blank"
        onClick={onButtonClick}
      >
        О методе проверки
      </LinkButton>
    </article>
  );
}
